import CommonError from '@/common/utils/errors/CommonError';

type EntitiesArgs = {
  Model?: any
  items?: CommonObject[]
}

type EntityById = {
  [key: string]: any
}

type Entity = {
  byId: EntityById
  ids: ID[]
}

export default function createEntities({ Model = Object, items }: EntitiesArgs = {}): Entity {
  if (!Model || !items) {
    throw new CommonError('Specify required arguments to create entities');
  }

  return items.reduce((result: Entity, item) => {
    const instance = new Model(item);
    const { id } = instance;
    if (id === undefined) {
      throw new CommonError('Unique id is absent in Model');
    }

    result.byId[id] = instance;
    result.ids.push(id);

    return result;
  }, { byId: {}, ids: [] });
}
